import React, { useState, useEffect } from "react";
import { AppBar, Toolbar, Box, IconButton, Drawer, List, ListItem, ListItemText } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";

const Header = () => {
    const [isSticky, setIsSticky] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false); // Track menu state

    useEffect(() => {
        const handleScroll = () => {
            setIsSticky(window.scrollY > 50);
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    return (
        <>
            {/* Header */}
            <AppBar
                position="relative"
                sx={{
                    backgroundColor: "white",
                    boxShadow: isSticky ? "0px 4px 6px rgba(0,0,0,0.1)" : "none",
                    transition: "transform 0.3s ease-in-out",
                    top: 0,
                    left: 0,
                    width: "100%",
                    zIndex: 1000,
                    padding: "5px 10px",
                }}
            >
                <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
                    {/* Logo */}
                    <Box component="img"
                        src="https://govirtual.ph/wp-content/uploads/2023/12/gv-logo-horizontal.png" // Replace with actual logo
                        alt="GoVirtual Logo"
                        sx={{
                            height: 40,
                            cursor: "pointer",
                            objectFit: "contain",
                        }}
                    />

                    {/* Hamburger Menu */}
                    <IconButton edge="end" onClick={() => setMenuOpen(true)}>
                        <MenuIcon sx={{ color: "gray", fontSize: 32 }} />
                    </IconButton>
                </Toolbar>
            </AppBar>

            {/* Sidebar Drawer (Mobile Menu) */}
            <Drawer anchor="right" open={menuOpen} onClose={() => setMenuOpen(false)}>
                <Box sx={{ width: 250 }}>
                    <IconButton onClick={() => setMenuOpen(false)} sx={{ m: 2 }}>
                        <CloseIcon />
                    </IconButton>
                    <List>
                        <ListItem button>
                            <ListItemText primary="Home" />
                        </ListItem>
                        <ListItem button>
                            <ListItemText primary="About Us" />
                        </ListItem>
                        <ListItem button>
                            <ListItemText primary="Events" />
                        </ListItem>
                        <ListItem button>
                            <ListItemText primary="Contact" />
                        </ListItem>
                    </List>
                </Box>
            </Drawer>
        </>
    );
};

export default Header;
